import { useRoute } from '@react-navigation/native';
import { WebviewScreenLayout } from 'shared/src/component';
import { useNavigationGoBack, useWebviewUri } from 'shared/src/hooks';
import { isNil } from 'shared/src/utils';
import { fillWebRoutePath } from 'shared/src/webRoutePaths';

/** `/orders/:orderSno` 의 path/query 파라미터. query 는 그대로 웹뷰 URL 로 승계한다. */
type OrderDetailRouteParams = {
  orderSno?: string;
} & Record<string, string | undefined>;

/**
 * 주문 상세 화면(내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 Cart 와 같다 — 범용 `WebViewScreen` 으로 열면 목적지가 `url`
 * params 문자열로 들어가 주소가 `/orders/123` 으로 유지되지 않는다(뒤에 인코딩된 URL 이
 * 붙는 형태). Navigator 에 `path` 로 등록해 주소를 유지한다.
 */
export const OrderDetailScreen = () => {
  const route = useRoute();
  const { orderSno, ...restParams } = (route.params ??
    {}) as OrderDetailRouteParams;
  const navigationGoBack = useNavigationGoBack();

  const uri = useWebviewUri(
    isNil(orderSno) ? undefined : fillWebRoutePath('OrderDetail', { orderSno }),
    restParams,
  );

  return (
    <WebviewScreenLayout
      title={'주문 상세'}
      uri={uri}
      showHeader={true}
      onPressBack={navigationGoBack}
    />
  );
};
